import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { GlobalConstants } from '../../../common/constants/global.constant';

@Component({
  selector: 'iposcen-ipos-help-idle-assistant',
  templateUrl: './ipos-help-idle-assistant.component.html',
  styleUrls: ['./ipos-help-idle-assistant.component.scss']
})
export class IposHelpIdleAssistantComponent implements OnInit {
  @ViewChild('idleAssistant') idleAssistant: ElementRef;
  @ViewChild('sectionA') sectionA: ElementRef;
  @ViewChild('sectionB') sectionB: ElementRef;
  isSectionA = true;
  isSectionB = true;
  storeLink: string;
  idleAssistantText = GlobalConstants.IDLE_ASSISTANT_HELP_TITLE_TEXT;
  constructor() { }

  ngOnInit(): void {
    this.storeLink = 'https://play.google.com/store/apps/details?id=com.uk.digitas.intelchromebookapp';
  }

  change(data) {
    if (data === 'idleAssist') {
      setTimeout(() => {
        this.idleAssistant.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'idleAssist_sectionA') {
      setTimeout(() => {
        this.sectionA.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'idleAssist_sectionB') {
      setTimeout(() => {
        this.sectionB.nativeElement.scrollIntoView();
      }, 0);
    }
  }

  navigate() {
    window.open(this.storeLink, '_blank');
  }

  showDescription(data) {
    if (data === 'sectionA') {
      this.isSectionA = !this.isSectionA;
    } else if (data === 'sectionB') {
      this.isSectionB = !this.isSectionB;
    }
  }

}
